<p-confirmDialog key="sendEmergencyAnnouncementCD"></p-confirmDialog>
<div class="layout-main emergency-announcement-page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 page-header">
        <h2 class="page-title">
          <b>Send an emergency announcement</b>
        </h2>
      </div>
    </div>
    <div class="alert alert-warning" role="alert">
      <i class="fa fa-exclamation-triangle pr-2"></i>
      Please use this function only when the Announcement system is down.
    </div>
    <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
      {{ errorMessage }}
      <button (click)="error = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="success" class="alert alert-success alert-dismissible fade show">
      {{ successMessage }}
      <button (click)="success = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row content-row">
      <div class="col-12 col-xl-8 mb-4">
        <div class="content-card">
          <div class="form-group mb-4">
            <label class="section-label">Available to clients</label>
            <p-multiSelect
              [(ngModel)]="emergencyAnnouncement.companiesUniqId"
              [options]="companiesItems"
              [style]="{'width':'100%'}"
              placeholder="Select companies"
              filter="true"
              name="availableToClients"
              optionLabel="label">
            </p-multiSelect>
          </div>
          <div class="form-group mb-4">
            <label class="field-label">Subject</label>
            <input
              #name="ngModel"
              [(ngModel)]="emergencyAnnouncement.subject"
              class="form-control"
              maxlength="255"
              name="subject"
              pInputText
              placeholder="Enter the announcement subject"
              type="text">
          </div>
          <div class="form-group mb-4">
            <label class="field-label">Message</label>
            <div class="editor-wrapper">
              <p-editor
                [(ngModel)]="emergencyAnnouncement.message"
                name="message"
                [style]="{'height':'220px'}"
                placeholder="Body">
              </p-editor>
            </div>
          </div>
          <div class="form-group row col-6 align-items-center mt-3">
            <div class="col-1">
              <p-checkbox
                #ccMckay="ngModel"
                [(ngModel)]="emergencyAnnouncement.isCcMckay"
                [binary]="true" name="ccMckay">
              </p-checkbox>
            </div>
            <label class="col-7 col-form-label">
              Cc: Mckay Brothers users
            </label>
          </div>
          <div class="form-group col-12">
            <label class="control-label col-4">Banner and footer</label>
            <div class="col-8 no-padding">
              <div class="custom-control custom-checkbox">
                <div *ngFor="let lab of bannersOptions" class="custom-control custom-checkbox margin-bottom-10">
                  <p-radioButton #banner="ngModel" [(ngModel)]="emergencyAnnouncement.banner" label={{lab.label}}
                                 name="label{{lab.value}}" value={{lab.value}}></p-radioButton>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mt-4">
            <button (click)="initForm()"
                    class="btn btn-outline-secondary mr-2" id="cancel_button">
              <i class="fa fa-refresh pr-2"></i>
              Cancel
            </button>
            <button (click)="previewEmail()"
                    class="btn btn-outline-primary mr-2" id="preview_button">
              <i class="fa fa-eye pr-2"></i>
              Preview Email
            </button>
            <button
              class="btn btn-outline-primary"
              [disabled]="isSentDisabled()"
              id="send_button" (click)="sendAnnouncement()">
              <i class="fa fa-send-o pr-2"></i>
              Send
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-4 mb-4">
        <div class="content-card roles-card">
          <div class="section-header">
            <h3 class="section-title font-weight-bolder">Roles</h3>
          </div>
          <div class="roles-list">
            <div
              *ngFor="let role of groupsItems"
              class="custom-control custom-checkbox mb-3">
              <p-checkbox
                #group="ngModel"
                [(ngModel)]="selectedGroups"
                [disabled]="role.disabled === true"
                label="{{role.label}}"
                (onChange)="setSelectedGroup()"
                name="group{{role.value}}"
                value="{{role.value}}">
              </p-checkbox>
              <small
                *ngIf="!!role.title" class="form-text text-muted" style="font-size:13px">
                {{ role.title }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p-dialog [(visible)]="display" dismissableMask="true" header="{{title}}" modal="true">
      <div class="form-group" style="text-align: center;">
        <img alt="" src="{{srcImg}}">
      </div>
      <div [innerHTML]="messagePreview" style="font-size: 12px"></div>
      <br>
      <br>
      <p [innerHTML]="getFooter()" style="color: grey; font-size: 12px">
      </p>
    </p-dialog>
  </div>
</div>
